import { useMemo } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import queryString from "querystring";

const useRouter = () => {
  const params = useParams();
  const location = useLocation();
  const history = useHistory();
  // const match = useRouteMatch();

  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(() => {
    return {
      // For convenience add push(), replace(), pathname at top level
      push: history.push,
      replace: history.replace,
      pathname: location.pathname,
      href: location.pathname + location.search,
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        ...queryString.parse(location.search.slice(1)), // Convert string to object
        ...params,
      },
      // Include match, location, history objects so we have
      // access to extra React Router functionality if needed.
      // match: match || {},
      location,
      history,
    };
  }, [params, location, history]);
};
export default useRouter;
